import { isArray, isString } from 'utils/check';

type ApiErrorBody = {
  message?: string;
  detail?: string | Array<{ msg?: string; loc?: unknown[] }>;
  status?: string;
};

const SKIP_LOC_PARTS = new Set(['body', 'query', 'path', 'header']);

function formatValidationItem(item: { msg?: string; loc?: unknown[] }): string | null {
  const msg = item.msg?.trim();
  if (!msg) {
    return null;
  }
  const field = Array.isArray(item.loc)
    ? [...item.loc]
        .reverse()
        .find((part) => typeof part === 'string' && !SKIP_LOC_PARTS.has(part))
    : undefined;
  if (typeof field === 'string' && msg.startsWith('Строка ')) {
    const label = field.charAt(0).toUpperCase() + field.slice(1);
    return `${label}${msg.slice('Строка'.length)}`;
  }
  return msg;
}

export function getApiErrorMessage(error: unknown, fallback = 'Что-то пошло не так'): string {
  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const axiosError = error as {
    code?: string;
    response?: { data?: ApiErrorBody };
    message?: string;
  };

  if (
    axiosError.code === 'ECONNABORTED' ||
    axiosError.code === 'ERR_NETWORK' ||
    axiosError.code === 'ETIMEDOUT'
  ) {
    return 'Сервер не ответил вовремя. Попробуйте еще раз.';
  }

  const data = axiosError.response?.data;
  if (data?.message && isString(data.message)) {
    return data.message;
  }

  const detail = data?.detail;
  if (isString(detail)) {
    return detail;
  }
  if (detail && typeof detail === 'object' && !isArray(detail)) {
    const nested = (detail as { message?: unknown }).message;
    if (isString(nested) && nested.trim()) {
      return nested;
    }
  }

  if (isArray(detail)) {
    const parts = detail
      .map((item) => formatValidationItem(item as { msg?: string; loc?: unknown[] }))
      .filter((msg): msg is string => Boolean(msg));
    if (parts.length > 0) {
      return parts.join('. ');
    }
  }

  if (axiosError.message && !axiosError.message.startsWith('Request failed with status code')) {
    return axiosError.message;
  }

  return fallback;
}

export function getApiSuccessMessage(
  data: ApiErrorBody | undefined,
  fallback = 'Готово',
): string {
  if (data?.message && isString(data.message)) {
    return data.message;
  }
  return fallback;
}
